import gql from 'graphql-tag'

export const GET_ALL_REQUEST_TICKETS = gql`
  fragment projectAsTarget on Project {
    name
    brand {
      name
      avatar {
        cloudinaryId
        cloudinaryType
      }
    }
  }

  fragment shootAsTarget on Shoot {
    name
    project {
      ... on Project {
        ...projectAsTarget
      }
    }
  }

  fragment videoAsTarget on Video {
    name
    project {
      ... on Project {
        ...projectAsTarget
      }
    }
  }

  query getAllRequestTickets(
    $page: Int
    $pageSize: Int
    $orderDirection: OrderDirection
    $states: [RequestTicketState!]
    $requesterTypes: [RequestTicketRequesterType!]
    $assigneeEmail: [String]
    $requestTypeName: [String]
    $billingOrganisationUuid: [ID]
    $urgency: [RequestTicketUrgency]
  ) {
    allRequestTickets(
      page: $page
      pageSize: $pageSize
      orderDirection: $orderDirection
      states: $states
      requesterTypes: $requesterTypes
      assigneeEmail: $assigneeEmail
      requestTypeName: $requestTypeName
      billingOrganisationUuid: $billingOrganisationUuid
      urgency: $urgency
    ) {
      pageInfo {
        currentPage
        lastPage
        totalCount
      }
      requestTickets {
        uuid
        createdAt
        scheduledFor
        urgency
        state
        requesterType
        moderator {
          ... on User {
            name
            avatar {
              cloudinaryId
              cloudinaryType
            }
          }
        }
        assignee {
          ... on User {
            name
            avatar {
              cloudinaryId
              cloudinaryType
            }
          }
        }
        target {
          ... on Project {
            ...projectAsTarget
          }
          ... on Shoot {
            ...shootAsTarget
          }
          ... on Video {
            ...videoAsTarget
          }
        }
        requestTicketType {
          title
          requestType
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/ProducerRequests/queries/all-requests.ts